import { baseUrl, config } from "./constGlobals";
// @ts-ignore
import { trackUserAction } from "@viuti/recursos";

import axios from "axios";
import { emitPlanLimitIfAny } from "../../../utils/planLimit/emitPlanLimit";

export const postEmployeeService = async (data) => {
  const url = `${baseUrl}/invitation`;
  const invita_miembro = 46;
  trackUserAction(invita_miembro);

  let obj: any = {
    email: data.email,
    name: data.name,
    accessComanda: data.accessComanda,
    accessSystem: data.accessSystem,
  };

  if (data.role !== undefined && data.role !== null) {
    obj.role = data.role;
  }

  try {
    const response: IResponse = await axios.post(url, obj, config);
    return {
      isSuccess: true,
      status: response.data?.status || response.status,
      message: response.data?.message || "Invitación enviada con éxito",
      data: response.data?.data || response.data,
    };
  } catch (error) {
    // El backend responde el cuerpo tipificado de EmployeeExistsInLocalException
    // (code + idEmployee + canResendInvitation) en la RAÍZ del body, igual que las
    // excepciones de plan. Antes se leía `data.data.idEmploye` —con la ruta anidada
    // equivocada y un typo en la clave—, así que el id nunca llegaba y la página
    // terminaba decidiendo por el texto del mensaje.
    const body = error?.response?.data || {};
    // Spec 007: sin cupo de usuarios → modal global de límite.
    emitPlanLimitIfAny(body);
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message:
        body.message || "Ups! ocurrió un problema, vuelva a intentarlo mas tarde.",
      code: body.code || null,
      data: {
        idEmployee: body.idEmployee ?? null,
        canResendInvitation: !!body.canResendInvitation,
      },
    };
  }
};

export const resendInviteService = async (idEmployee: number) => {
  const url = `${baseUrl}/re-invitation`;
  const reenvia_invitacion = 48;
  trackUserAction(reenvia_invitacion);
  try {
    const response: IResponse = await axios.post(url, { id: idEmployee }, config);

    return {
      isSuccess: true,
      status: response.data.status,
      message: response.data.message,
      data: response.data.data,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message:
        error?.response?.data?.message ||
        "Ups! ocurrió un problema, vuelva a intentarlo mas tarde.",
      data: null,
    };
  }
};

export const addEmployeeServicesService = async (body: {
  idService: number;
  idEmployee: number;
}) => {
  const url = `${baseUrl}/services`;
  try {
    const response: IResponse = await axios.post(url, body, config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
